<template>
	<div class="eu" v-if="label">
		<div class="wrapper eu-wrapper" v-html="label" />
	</div>
</template>

<script setup>
	const labels = useLabels();
	const label = labels.get('eu');
</script>

<style scoped lang="less">
	.eu {
		border-top: 1px solid @borderColor; font-size: 13px; content-visibility: auto; contain-intrinsic-size: 115px;
		:deep(img) {
			max-height: 35px; width: auto;
			&:not(:last-child) {
				margin-right: 10px;
			}
			@media (max-width: @m) {
				max-height: 22px;
			}
		}
		@media (max-width: @m) {
			font-size: 12px;
		}
		p {
			padding: 0;
			@media (max-width: @l) {
				&:last-child { padding: 0; }
				padding-bottom: 10px;
			}
		}
	}
	.eu-wrapper {
		display: flex; flex-wrap: wrap; padding: 30px 0; justify-content: space-between; align-items: center;
		:deep(p){
			&:first-child{
				display: flex; flex-wrap: wrap; gap: 10px;
			}
		}
		@media (max-width: @m) {
			padding: 20px 0;
		}
	}
</style>
